import { render } from "./DraggableKanBanDemo.vue?vue&type=template&id=b20f9b78&scoped=true"
import script from "./DraggableKanBanDemo.vue?vue&type=script&lang=ts"
export * from "./DraggableKanBanDemo.vue?vue&type=script&lang=ts"

import "./DraggableKanBanDemo.vue?vue&type=style&index=0&id=b20f9b78&lang=scss"
import "./DraggableKanBanDemo.vue?vue&type=style&index=1&id=b20f9b78&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b20f9b78"

export default script